import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { AdminPageHeader, Card, Spinner, ErrorBanner, EmptyState, Tag } from "./_shared";
import { Archive as ArchiveIcon } from "lucide-react";

export const Archives = () => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/archives")
      .then((r) => setRows(r.data.archives || []))
      .catch((e) => setErr(e?.response?.data?.detail || "Failed to load archives."));
  }, []);

  return (
    <div className="space-y-5" data-testid="archives-page">
      <AdminPageHeader
        eyebrow="ARCHIVES"
        title="Past Questions"
        sub="Snapshots of every closed question — totals, upvotes, top categories."
      />
      {err && <ErrorBanner message={err} />}
      {!rows && !err && <Spinner />}
      {rows && rows.length === 0 && <EmptyState title="No archives yet." sub="Archive a question to create a snapshot." />}
      {rows && rows.length > 0 && (
        <div className="grid md:grid-cols-2 gap-4" data-testid="archives-grid">
          {rows.map((a) => (
            <Card key={a.id} testId={`archive-${a.id}`}>
              <div className="flex items-start gap-3 mb-3">
                <ArchiveIcon size={18} strokeWidth={3} style={{ color: "#FF9933" }} />
                <div className="flex-1 min-w-0">
                  <p className="font-display uppercase text-lg leading-none">{a.source_poll_id}</p>
                  <p className="text-[10px] uppercase font-bold tracking-[0.3em] text-neutral-500 mt-1">
                    Archived {a.archived_at?.slice(0, 16).replace("T", " ")}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <p className="text-[10px] uppercase font-bold tracking-[0.3em] text-neutral-400">Messages</p>
                  <p className="font-display text-2xl">{(a.total_messages || 0).toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-[10px] uppercase font-bold tracking-[0.3em] text-neutral-400">Upvotes</p>
                  <p className="font-display text-2xl" style={{ color: "#FF9933" }}>{(a.total_upvotes || 0).toLocaleString()}</p>
                </div>
              </div>
              {a.top_categories?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {a.top_categories.map((c) => (
                    <Tag key={c._id} color="#FF9933">{c._id} · {c.n}</Tag>
                  ))}
                </div>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Archives;
